import { Menu } from 'lucide-react';

interface HeaderProps {
  onMenuToggle: () => void;
}

export default function Header({ onMenuToggle }: HeaderProps) {
  return (
    <header
      className="flex h-14 items-center border-b px-6 lg:hidden"
      style={{
        borderColor: 'var(--border-soft)',
        background: 'color-mix(in srgb, var(--surface) 80%, transparent)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <button
        onClick={onMenuToggle}
        className="rounded-lg p-2 transition-colors"
        style={{ color: 'var(--muted)' }}
      >
        <Menu size={20} />
      </button>
      <span className="ml-3 display-font text-sm font-semibold" style={{ color: 'var(--ink)' }}>
        HelpDesk
      </span>
    </header>
  );
}
